import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "p-5"
};
const _hoisted_3 = { class: "subtitle" };
const _hoisted_4 = { class: "columns" };
const _hoisted_5 = { class: "column" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Partner", -1);
const _hoisted_7 = { key: 0 };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Profile", -1);
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { class: "horizontal" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle mb-4" }, "Case Workers", -1);
const _hoisted_12 = { class: "ml-5 pb-4" };
const _hoisted_13 = ["href"];
const _hoisted_14 = { class: "table is-hoverable is-fullwidth" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("thead", null, null, -1);
const _hoisted_16 = { class: "is-flex is-justify-content-space-between" };
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = { key: 2 };
const _hoisted_21 = { key: 3 };
import TypeAhead from "@/components/TypeAhead.vue";
import { useAsync } from "@/composables/useAsync";
import { Core } from "@minicity/core";
import { isFeatureEnabled, sessionState } from "@/core/session";
import { notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import { apiPartnerUsers } from "@/features/partnerUsers/api";
import { ref, onMounted, watch } from "vue";
import SiteProfileEditor from "./SiteProfileEditor.vue";
import { apiSites } from "./api";
import { Site } from "@minicity/core";
import { watchQueryParam } from "@/composables/watchQueryParam";
var Tab;
(function (Tab) {
    Tab["DETAILS"] = "Site Details";
    Tab["CASEWORKERS"] = "Assigned Caseworkers";
    Tab["COMMENTS"] = "Comments";
    Tab["TASKS"] = "Tasks";
})(Tab || (Tab = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'SiteDetailPanel',
    props: {
        siteId: {}
    },
    setup(__props) {
        const props = __props;
        // Tabs
        const activeTab = ref(Tab.DETAILS);
        watch(activeTab, watchQueryParam(activeTab, 'tab'));
        const profileEditorElem = ref(null);
        const inProgressAction = ref(null);
        onMounted(() => {
            if (new URL(window.location.toString()).searchParams.has('taskId')) {
                activeTab.value = Tab.TASKS;
            }
        });
        const updateSite = () => {
            if (inProgressAction.value)
                return;
            if (!profileEditorElem.value.areAllFieldsValid) {
                notifyError("Please check for invalid form inputs");
                return;
            }
            inProgressAction.value = `saveSite`;
            apiSites.update(site.data)
                .then(() => {
                notifySuccess("Site saved");
            })
                .catch(err => {
                notifyNetworkError("Failed to update site", err);
            })
                .finally(() => {
                inProgressAction.value = null;
            });
        };
        //-----
        // Add / Remove Caseworkers from List
        const caseWorkerToRemove = ref(null);
        const doRemoveCaseWorker = (cw) => {
            apiSites.deleteSitePartnerUserAssignment(site.data.id, cw.id, Site.PartnerUserRole.CASEWORKER)
                .then(() => {
                notifySuccess("Caseworker assignment removed");
                for (let i = 0; i < site.data.assignedPartnerUsers.length; ++i) {
                    let entry = site.data.assignedPartnerUsers[i];
                    if (entry.partnerUser.id == cw.id && entry.role == Site.PartnerUserRole.CASEWORKER) {
                        site.data.assignedPartnerUsers.splice(i, 1);
                        break;
                    }
                }
            })
                .catch(err => notifyNetworkError("Failed to remove caseworker assignment", err));
            caseWorkerToRemove.value = null;
        };
        const addCaseworker = (cw) => {
            apiSites.addSitePartnerUserAssignment(site.data.id, cw.id, Site.PartnerUserRole.CASEWORKER)
                .then(() => {
                var _a;
                notifySuccess("Caseworker assignment added");
                (_a = site.data) === null || _a === void 0 ? void 0 : _a.assignedPartnerUsers.push({ partnerUser: cw, role: Site.PartnerUserRole.CASEWORKER });
            })
                .catch(err => notifyNetworkError("Failed to add caseworker assignment", err));
        };
        //---
        // Fetch sites from API
        const site = useAsync();
        const allCaseworkers = useAsync();
        if (sessionState.session) {
            site.fetch(apiSites.get(props.siteId), "Failed to load site")
                .then(resp => {
                allCaseworkers.fetch(apiPartnerUsers.getForPartner(site.data.partner.id), "Failed to load caseworkers");
            });
        }
        //------
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            const _component_HeaderSectionLayout = _resolveComponent("HeaderSectionLayout");
            const _component_TabsHeader = _resolveComponent("TabsHeader");
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_UserBadge = _resolveComponent("UserBadge");
            const _component_CommentSection = _resolveComponent("CommentSection");
            const _component_TaskSection = _resolveComponent("TaskSection");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(isFeatureEnabled)('SITES'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_unref(site).status == 'loading')
                            ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                            : (_unref(site).status == 'ready')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(_component_HeaderSectionLayout, null, {
                                        title: _withCtx(() => [
                                            _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(site).data.name), 1)
                                        ]),
                                        fields: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_4, [
                                                _createElementVNode("div", _hoisted_5, [
                                                    _hoisted_6,
                                                    _createVNode(_component_PartnerBadge, {
                                                        partner: _unref(site).data.partner
                                                    }, null, 8, ["partner"])
                                                ])
                                            ])
                                        ]),
                                        networkAdminControls: _withCtx(() => []),
                                        partnerControls: _withCtx(() => []),
                                        _: 1
                                    }),
                                    _createVNode(_component_TabsHeader, {
                                        modelValue: activeTab.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((activeTab).value = $event)),
                                        tabs: Tab,
                                        entityType: _unref(Core).EntityType['Partner Site'],
                                        entityId: _unref(site).data.id
                                    }, null, 8, ["modelValue", "entityType", "entityId"]),
                                    (activeTab.value == Tab.DETAILS)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _hoisted_8,
                                            _createVNode(SiteProfileEditor, {
                                                modelValue: _unref(site).data,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(site).data) = $event)),
                                                ref_key: "profileEditorElem",
                                                ref: profileEditorElem
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_SaveButton, {
                                                label: "Save Form",
                                                icon: "fa-save",
                                                action: "saveSite",
                                                inProgressAction: inProgressAction.value,
                                                onClick: _cache[2] || (_cache[2] = ($event) => (updateSite()))
                                            }, null, 8, ["inProgressAction"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (activeTab.value == Tab.CASEWORKERS)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _hoisted_11,
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("a", {
                                                        href: `/onboarding/partnerUser/${encodeURIComponent(_unref(site).data.inviteCode)}`,
                                                        target: "_blank"
                                                    }, [
                                                        _createVNode(_component_SaveButton, {
                                                            label: "Invite New User",
                                                            icon: "fa-plus"
                                                        })
                                                    ], 8, _hoisted_13)
                                                ])
                                            ]),
                                            _createElementVNode("table", _hoisted_14, [
                                                _hoisted_15,
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(site).data.assignedPartnerUsers.filter(assignment => assignment.role == 'CASEWORKER'), (userAssignment) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: userAssignment.partnerUser.id
                                                        }, [
                                                            _createElementVNode("td", _hoisted_16, [
                                                                _createVNode(_component_UserBadge, {
                                                                    user: userAssignment.partnerUser
                                                                }, null, 8, ["user"]),
                                                                _createElementVNode("button", {
                                                                    onClick: ($event) => (caseWorkerToRemove.value = userAssignment.partnerUser)
                                                                }, _hoisted_19, 8, _hoisted_17)
                                                            ])
                                                        ]));
                                                    }), 128)),
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("td", null, [
                                                            (_unref(allCaseworkers).data)
                                                                ? (_openBlock(), _createBlock(TypeAhead, {
                                                                    key: 0,
                                                                    "prop-data": _unref(allCaseworkers).data,
                                                                    onItemSelected: _cache[3] || (_cache[3] = ($event) => (addCaseworker($event))),
                                                                    placeholder: "Type to add caseworker...",
                                                                    icon: "fas fa-user",
                                                                    labelField: "displayName"
                                                                }, null, 8, ["prop-data"]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (activeTab.value == Tab.COMMENTS)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createVNode(_component_CommentSection, {
                                                getComments: () => _unref(apiSites).getComments(_unref(site).data.id),
                                                addComment: (message, attachments, notifyCaseworker) => _unref(apiSites).addComment(_unref(site).data.id, message, attachments, notifyCaseworker),
                                                getAttachmentViewLink: (commentId, attachmentId) => _unref(apiSites).getCommentAttachmentViewLink(_unref(site).data.id, commentId, attachmentId)
                                            }, null, 8, ["getComments", "addComment", "getAttachmentViewLink"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (activeTab.value == Tab.TASKS)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createVNode(_component_TaskSection, {
                                                allowShowAll: "",
                                                getTasks: () => _unref(apiSites).getTasks(_unref(site).data.id),
                                                addTask: (audience, message) => _unref(apiSites).addTask(_unref(site).data.id, audience, message)
                                            }, null, 8, ["getTasks", "addTask"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_ModalDialog, {
                    active: caseWorkerToRemove.value != null,
                    title: "Confirm Removal",
                    "allow-close": true,
                    onClose: _cache[4] || (_cache[4] = ($event) => (caseWorkerToRemove.value = null)),
                    "first-button-text": "Go Back",
                    "first-button-severity": "link",
                    onFirstbuttonselected: _cache[5] || (_cache[5] = ($event) => (caseWorkerToRemove.value = null)),
                    "second-button-text": "Remove",
                    "second-button-severity": "danger",
                    onSecondbuttonselected: _cache[6] || (_cache[6] = ($event) => (doRemoveCaseWorker(caseWorkerToRemove.value)))
                }, {
                    default: _withCtx(() => {
                        var _a, _b;
                        return [
                            _createElementVNode("p", null, [
                                _createElementVNode("strong", null, "Remove " + _toDisplayString((_a = caseWorkerToRemove.value) === null || _a === void 0 ? void 0 : _a.displayName) + " from " + _toDisplayString((_b = _unref(site).data) === null || _b === void 0 ? void 0 : _b.name) + "?", 1)
                            ])
                        ];
                    }),
                    _: 1
                }, 8, ["active"])
            ], 64));
        };
    }
});
